// extracted by mini-css-extract-plugin
module.exports = {"downloadCheck":"InvoiceDownload_downloadCheck__1a-wS","downloadCheckDescripition":"InvoiceDownload_downloadCheckDescripition__3hP7u"};